import { Paper } from '@mantine/core'
import classes from './Paper.module.css'

export const PaperThemeKobo = Paper.extend({
  classNames: classes,
})
